import {
  deleteRequest,
  downloadRequest,
  getRequest,
  patchRequest,
  postRequest,
  putRequest,
  replaceInUrl,
} from './index';
import apiEndpoints from './apiEndpoints';

export const getApplicationRequest = ({ ApplicationUid }) =>
  getRequest(
    replaceInUrl(apiEndpoints.applications.getApplication, {
      ApplicationUid,
    }),
  );

export const setupApplicationTypeRequest = ({ ApplicationUid, data }) =>
  postRequest(
    replaceInUrl(apiEndpoints.applications.createApplicationType, {
      ApplicationUid,
    }),
    data,
  );

export const createAccountTypeRequest = ({ ApplicationUid, data }) =>
  postRequest(
    replaceInUrl(apiEndpoints.applications.createAccountType, {
      ApplicationUid,
    }),
    data,
  );

export const patchAccountTypeRequest = ({ ApplicationUid, data }) =>
  putRequest(
    replaceInUrl(apiEndpoints.applications.patchAccountType, {
      ApplicationUid,
    }),
    data,
  );

export const deleteApplicationRequest = ({ ApplicationUid }) =>
  deleteRequest(
    replaceInUrl(apiEndpoints.applications.deleteApplication, {
      ApplicationUid,
    }),
  );

export const createApplicationStepRequest = ({ ApplicationUid, data }) =>
  postRequest(
    replaceInUrl(apiEndpoints.applications.createApplicationStep, {
      ApplicationUid,
    }),
    data,
  );

export const createApplicationRequest = ({ ApplicationUid, data, params }) =>
  postRequest(
    replaceInUrl(apiEndpoints.applications.createApplication, {
      ApplicationUid,
    }),
    data,
    params,
  );

export const downloadAgreementRequest = ({ ApplicationUid }) =>
  downloadRequest(
    replaceInUrl(apiEndpoints.applications.getAgreements, {
      ApplicationUid,
    }),
  );

export const completeApplicationRequest = ({ ApplicationUid, sessionId }) =>
  patchRequest(
    replaceInUrl(apiEndpoints.applications.patchApplication, {
      ApplicationUid,
      sessionId,
    }),
  );

export const createAchAgreementRequest = ({ ApplicationUid, data }) =>
  postRequest(
    replaceInUrl(apiEndpoints.applications.createAchAgreement, {
      ApplicationUid,
    }),
    data,
  );

export const createHaaAgreementRequest = ({ ApplicationUid, data }) =>
  postRequest(
    replaceInUrl(apiEndpoints.applications.createHaaAgreement, {
      ApplicationUid,
    }),
    data,
  );

export const createIraAgreementRequest = ({ ApplicationUid, data }) =>
  postRequest(
    replaceInUrl(apiEndpoints.applications.createIraAgreement, {
      ApplicationUid,
    }),
    data,
  );

export const upgradeApplicationRequest = ({ applicationUid }) =>
  patchRequest(
    replaceInUrl(apiEndpoints.applications.upgradeApplication, {
      applicationUid,
    }),
  );

export const referralAcceptedRequest = (data) =>
  postRequest(apiEndpoints.applications.referralAccepted, data);
